import React, { useContext } from 'react'
// import LanguageSwitcher from "./LanguageSwitcher";
import { Row, Col } from 'antd';
import { ApplicationContext, EViewPort } from 'App/context'
import UserMenu from './UserMenu'
import LoadableLogo from 'App/components/LoadableLogo'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

const TopBar = () => {
  const ctx = useContext(ApplicationContext)

  const showCollapseTrigger = () => {
    if (ctx.viewPort === EViewPort.mobile){
      if(ctx.navigationCollapsed) {
        return <MenuUnfoldOutlined className='trigger' onClick={ctx.toggleNavigationCollapsed}/>
      } else {
        return <MenuFoldOutlined className='trigger' onClick={ctx.toggleNavigationCollapsed}/>
      }
    }
    return null
  }


  return (
    <Row align="middle" justify="end" gutter={[16, 16]}>
      <Col className="TriggerAndLogo" lg={16} md={10} xs={8}>
        {showCollapseTrigger()}
        <LoadableLogo />
      </Col>
      <Col lg={8} md={14} xs={16} style={{ textAlign: 'end' }} className="userOptions">
        <UserMenu />
      </Col>
    </Row>
  )
}

export default TopBar
